export default __webpack_public_path__ + "static/media/MelodyKim.7332ea19.jpeg";